import { render, staticRenderFns } from "./club-activities.vue?vue&type=template&id=9dd527c0&scoped=true&"
import script from "./club-activities.vue?vue&type=script&lang=ts&"
export * from "./club-activities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd527c0",
  null
  
)

export default component.exports